import vueMainInstance from "../../main";

const namespaced = true;

const state = {
  bookings: [],
  bookingDetails: null,
  status: ""
};

const getters = {
  bookingList: state => state.bookings,
  bookingDetails: state => state.bookingDetails,
  showBookingDetails: state => state.bookingDetails != null
};

const mutations = {
  setBookingList(state, bookingList) {
    state.bookings = bookingList;
  },
  setBookingDetails(state, bookingDetails) {
    state.bookingDetails = bookingDetails;
  },
  removeBookingDetails(state) {
    state.bookingDetails = null;
  }
};

const actions = {
  loadAllBookings({ commit }) {
    vueMainInstance.axios.get("booking/list").then(response => {
      commit("setBookingList", response.data);
    });
  },
  loadBookingDetails({ commit }, booking) {
    vueMainInstance.axios.post("booking/details", { id: booking.id }).then(resp => {
      console.log(resp.data);
      commit("setBookingDetails", resp.data);
    });
  },
  closeBookingDetails({ commit }) {
    commit("removeBookingDetails");
  }
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
